import React from 'react';

import { Checkbox } from '@/components/ui/checkbox';
import { CommandGroup, CommandItem } from '@/components/ui/command';
import { TagSwatch } from '../../../../../shared/components/Tag';
import { useClientFilters } from '../../../hooks';

const TagList = () => {
  const {
    activeFilters,
    filterOptions: { tags },
    toggleFilter,
  } = useClientFilters();

  const isSelected = (value) => activeFilters.tags.includes(value);

  return (
    <CommandGroup>
      {tags.map((tag) => (
        <CommandItem
          key={tag.id}
          onSelect={() => toggleFilter({ type: 'tags', value: tag.id })}
          value={tag.name}
        >
          <Checkbox checked={isSelected(tag.id)} />
          <TagSwatch color={tag.color} />
          <span className="truncate">{tag.name}</span>
        </CommandItem>
      ))}
    </CommandGroup>
  );
};

export default TagList;
